export const css = {
    root: '_13ujcJyT',
    output: '_2fQ1WPZY',
    bar: 'fYMhOF90',
    progress: '_3cxo4WSK',
    ' _key': 'apic-theme/apic/micro/dojo/progress'
};
export default css;
